import styles from './styles.module.scss';

export default function ImportGift({ exercicios, onConfirm,onCancel }) {
    console.log(exercicios)
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Confirmação de Exercícios</h2>
        <div className={styles.grid}>
          {exercicios.map((ex, idx) => (
            <div key={idx} className={styles.card}>
              <h3 className={styles.title}>{ex.title}</h3>
              <p className={styles.description}>{ex.description}</p>
              <ul className={styles.options}>
                {ex.json.steps.map((opt, i) => (
                  <li
                    key={i}
                    className={opt.dropAreas.includes('dropbox') ? styles.correct : styles.incorrect}
                  >
                    {opt.text} {opt.dropAreas.includes('dropbox')? '✅' : '❌'}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <button className={styles.confirmButton} onClick={() => onConfirm(exercicios)}>
          Confirmar Criação
        </button>
        <button className={styles.cancelButton} onClick={() => onCancel()}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
